import { Chip } from '@mui/material';

import { ResuscitationChipStyles } from 'src/constants/ChipStyles';
import {
    ResuscitationStrategies,
    ResuscitationStrategyDisplayLabels,
    ResuscitationStrategyType,
} from 'src/constants/ResuscitationStrategies';

interface ResuscitationChipProps {
    resuscitationStrategy?: ResuscitationStrategyType;
}

const ResuscitationChip = (props: ResuscitationChipProps) => {
    const { resuscitationStrategy } = props;
    const strategy = resuscitationStrategy ?? ResuscitationStrategies.UNKNOWN;

    return (
        <Chip
            {...ResuscitationChipStyles[strategy]}
            label={ResuscitationStrategyDisplayLabels[strategy]}
        />
    );
};

export default ResuscitationChip;
